import React, { useContext } from 'react'
import styled from 'styled-components'
import { useMutation, queryCache } from 'react-query'

import { useWithAuth } from '../../containers/App'
import { useNotifications } from '../../containers/Notifications'
import { AppContext } from '../../containers/App'

import UnitPatientList from './UnitPatientList'
import Table from '../TableNew/'
import colors from '../../styles/colors'
// @ts-ignore @todo add apprioprate declaration file
import tableIconRight from '../../images/tableIconRight.svg'
// @ts-ignore @todo add apprioprate declaration file
import tableIconDown from '../../images/tableIconDown.svg'

import type { Users, User } from './utils'

// @ts-ignore @todo add apprioprate declaration file
import editIcon from '../../images/grayEditIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import userDiagnosedIcon from '../../images/userDiagnosedIcon.svg'
import { Hidden } from '../../styles/Shared'

const renderRowSubComponent = (row) => {
  return <UnitPatientList currentRowUserData={row.original} />
}
function UnitUserList({
  patients,
  onSortedChange,
  onPageChange,
  page,
  total,
  defaultPageSize,
  setEditUserModalReady,
  handleModalStates,
}) {
  const withAuth = useWithAuth()
  const user = useContext<User>(AppContext)
  const { notify } = useNotifications()
  const handleDiagnosticChange = async (rowData) => {
    try {
      const patients = await fetchDiagosticPatients(rowData)
      patients.models.length > 0
        ? notify(
            'Brak możliwości odłączenia diagnosty od jednostki jeśli są do niego przypięte osoby diagnozowane',
            'error'
          )
        : mutate(rowData)
    } catch {
      notify('Nie udało się odłączyć diagnosty od jednostki', 'error')
    }
  }

  const fetchDiagosticPatients = async (rowData) => {
    const result = await withAuth(`/diagnostic/rest/patient/search`, {
      method: 'POST',
      payload: {
        filters: {
          unitId: user.unitId,
          diagnosticians: [rowData.id],
        },
        meta: {
          limit: 1,
          page: 0,
        },
      },
    })
    return result
  }

  const [mutate] = useMutation<any, Users>((values) =>
    withAuth(`/user/rest/user/${values.id}`, {
      method: 'PUT',
      //TODO figure out why roleNames arent fetched
      payload: { ...values, unitId: null, roleNames: ['diagnostician'] },
    })
      .then((res) => {
        if ('fieldErrors' in res) {
          // @todo notifications
        } else {
          handleModalStates('')
          notify('Odłączono diagnostę od jednostki', 'success')
        }
      })
      .catch(console.log)
  )

  return (
    <Table
      data={patients}
      renderRowSubComponent={renderRowSubComponent}
      page={page}
      total={total}
      onSortedChange={onSortedChange}
      onPageChange={(index) => onPageChange(index)}
      defaultPageSize={defaultPageSize}
      addAriaLabelToHeader={true}
      columns={[
        {
          Header: <Hidden>Rozszerzenie tabeli</Hidden>,
          id: 'expander',
          Cell: ({ row }) => (
            <span
              aria-label={!row.isExpanded ? 'Rozszerz tabelę' : 'Zwiń tabelę'}
              {...row.getToggleRowExpandedProps()}
            >
              {row.isExpanded ? (
                <StyledIcon
                  role="alert"
                  aria-live="polite"
                  aria-label="tabela rozszerzona"
                  src={tableIconDown}
                  alt=""
                />
              ) : (
                <StyledIcon
                  role="alert"
                  aria-live="polite"
                  aria-label="tabela zwinięta"
                  src={tableIconRight}
                  alt=""
                />
              )}
            </span>
          ),
          SubCell: () => null,
        },
        {
          Header: 'Data dołączenia',
          id: 'creationDate',
          sortable: true,
          resizable: true,
          accessor: ({ creationDate }) => `${creationDate}`,
        },
        {
          Header: 'Imię',
          id: 'firstName',
          sortable: true,
          accessor: ({ firstName }) => `${firstName}`,
        },
        {
          Header: 'Nazwisko',
          id: 'lastName',
          sortable: true,
          accessor: ({ lastName }) => `${lastName}`,
        },
        {
          Header: 'Login',
          id: 'login',
          sortable: true,
          accessor: ({ login }) => `${login}`,
        },
        {
          Header: 'E-mail',
          sortable: true,
          id: 'emailAddress',
          accessor: ({ emailAddress }) => `${emailAddress}`,
        },

        {
          Header: 'Akcje',
          sortable: false,
          Cell: ({ cell }) => (
            <ActionsGridWrap>
              <IconButton
                onClick={() => setEditUserModalReady(cell.row.original)}
                type="button"
              >
                Edytuj
                <Img alt="" src={editIcon} aria-hidden="true" />
              </IconButton>
              <IconButton
                onClick={() => handleDiagnosticChange(cell.row.original)}
                type="button"
              >
                Odłącz od jednostki
                <Img alt="" src={userDiagnosedIcon} aria-hidden="true" />
              </IconButton>
            </ActionsGridWrap>
          ),
        },
      ]}
    />
  )
}

export default UnitUserList

const Img = styled.img`
  margin-bottom: 0;
`

const IconButton = styled.button`
  display: flex;
  margin-right: 1rem;
  background: white;
  border: 1px solid ${colors.light_black};
  &:hover {
    ${(props) => !props.disabled && `border: 1px solid ${colors.mantis_green};`}
  }
  &.danger {
    &:hover {
      border: 1px solid ${colors.red};
    }
  }
  align-items: center;
  cursor: ${(props) => !props.disabled && `pointer;`}
  height: 50px;
  border-radius: 5px;
  > * {
    padding: 0 0 0 3px;
  }
  ${Img} {
    opacity: ${(props) => props.disabled && `50%`};
  }`

const ActionsGridWrap = styled.div`
  display: flex;
  white-space: nowrap;
`
const StyledIcon = styled.img`
  display: flex;
`
